export const AMOUNTS = {
    KZT: [1, 5, 10, 50, 100, 500, 1000, 5000, 10000, 20000],
    RUB: [1, 5, 10, 50, 100, 500, 1000, 5000],
    USD: [1, 5, 10, 20, 50, 100],
    EUR: [1, 5, 10, 20, 50, 100, 200, 500],
    UZS: [1000, 5000, 10000, 20000, 50000, 100000],
    UAH: [1, 2, 5, 10, 20, 50, 100, 200, 500],
    AMD: [1000, 2000, 5000, 10000, 20000, 50000],
    KGS: [1, 5, 10, 20, 50, 100, 200, 500, 1000, 5000],
    GEL: [1, 2, 5, 10, 20, 50, 100, 200],
    GBP: [1, 2, 5, 10, 20, 50],
    TRY: [1, 5, 10, 20, 50, 100, 200],
    AED: [5, 10, 20, 50, 100, 200, 500, 1000],
    AFN: [10, 20, 50, 100, 500, 1000],
    ALL: [100, 200, 500, 1000, 2000, 5000],
    ANG: [5, 10, 25, 50, 100],
    AOA: [100, 200, 500, 1000, 2000],
    ARS: [10, 20, 50, 100, 200, 500, 1000],
    AUD: [5, 10, 20, 50, 100],
    AWG: [5, 10, 25, 50, 100],
    AZN: [1, 5, 10, 20, 50, 100, 200],
    BAM: [1, 2, 5, 10, 20, 50, 100, 200],
    BBD: [2, 5, 10, 20, 50, 100],
    BDT: [2, 5, 10, 20, 50, 100, 500, 1000],
    BGN: [1, 2, 5, 10, 20, 50, 100],
    BHD: [0.5, 1, 5, 10, 20],
    BIF: [1000, 2000, 5000, 10000],
    BMD: [1, 5, 10, 20, 50, 100],
    BND: [1, 5, 10, 50, 100],
    BOB: [10, 20, 50, 100, 200],
    BRL: [2, 5, 10, 20, 50, 100, 200],
    BSD: [1, 5, 10, 20, 50, 100],
    BTN: [5, 10, 20, 50, 100, 500, 1000],
    BWP: [10, 20, 50, 100, 200],
    BYN: [5, 10, 20, 50, 100],
    BZD: [2, 5, 10, 20, 50, 100],
    CAD: [5, 10, 20, 50, 100],
    CDF: [500, 1000, 5000, 10000, 20000],
    CHF: [10, 20, 50, 100, 200, 1000],
    CLP: [1000, 2000, 5000, 10000, 20000],
    CNY: [1, 5, 10, 20, 50, 100],
    COP: [1000, 2000, 5000, 10000, 20000, 50000],
    CRC: [1000, 2000, 5000, 10000, 20000, 50000],
    CUC: [1, 3, 5, 10, 20, 50, 100],
    CUP: [1, 3, 5, 10, 20, 50, 100],
    CVE: [100, 200, 500, 1000, 2000, 5000],
    CZK: [100, 200, 500, 1000, 2000, 5000],
    DJF: [1000, 2000, 5000, 10000],
    DKK: [50, 100, 200, 500, 1000],
    DOP: [50, 100, 200, 500, 1000, 2000],
    DZD: [100, 200, 500, 1000, 2000],
    EGP: [1, 5, 10, 20, 50, 100, 200],
    ERN: [1, 5, 10, 20, 50, 100],
    ETB: [10, 20, 50, 100, 200],
    FJD: [5, 10, 20, 50, 100],
    FKP: [5, 10, 20, 50],
    GHS: [1, 2, 5, 10, 20, 50, 100, 200],
    GIP: [5, 10, 20, 50, 100],
    GMD: [5, 10, 20, 50, 100, 200],
    GNF: [1000, 2000, 5000, 10000],
    GTQ: [1, 5, 10, 20, 50, 100, 200],
    GYD: [20, 50, 100, 500, 1000, 5000],
    HKD: [10, 20, 50, 100, 500, 1000],
    HNL: [1, 2, 5, 10, 20, 50, 100, 500],
    HRK: [10, 20, 50, 100, 200, 500, 1000],
    HTG: [10, 20, 50, 100, 250, 500, 1000],
    HUF: [500, 1000, 2000, 5000, 10000, 20000],
    IDR: [1000, 2000, 5000, 10000, 20000, 50000, 100000],
    ILS: [20, 50, 100, 200],
    INR: [10, 20, 50, 100, 200, 500, 2000],
    IQD: [250, 500, 1000, 5000, 10000, 25000],
    IRR: [10000, 20000, 50000, 100000],
    ISK: [500, 1000, 2000, 5000, 10000],
    JMD: [50, 100, 500, 1000, 5000],
    JOD: [1, 5, 10, 20, 50],
    JPY: [1000, 2000, 5000, 10000],
    KES: [50, 100, 200, 500, 1000],
    KHR: [100, 500, 1000, 2000, 5000, 10000, 20000],
    KMF: [500, 1000, 2000, 5000, 10000],
    KPW: [100, 200, 500, 1000, 2000, 5000],
    KRW: [1000, 5000, 10000, 50000],
    KWD: [0.25, 0.5, 1, 5, 10, 20],
    KYD: [1, 5, 10, 25, 50, 100],
    LAK: [1000, 2000, 5000, 10000, 20000, 50000],
    LBP: [1000, 5000, 10000, 20000, 50000, 100000],
    LKR: [20, 50, 100, 500, 1000, 5000],
    LRD: [5, 10, 20, 50, 100],
    LSL: [10, 20, 50, 100, 200],
    LYD: [1, 5, 10, 20, 50],
    MAD: [20, 50, 100, 200],
    MDL: [1, 5, 10, 20, 50, 100, 200, 500, 1000],
    MGA: [100, 200, 500, 1000, 2000, 5000, 10000],
    MKD: [10, 50, 100, 500, 1000, 2000],
    MMK: [50, 100, 200, 500, 1000, 5000, 10000],
    MNT: [10, 20, 50, 100, 500, 1000, 5000, 10000, 20000],
    MOP: [10, 20, 50, 100, 500, 1000],
    MRU: [5, 10, 20, 50, 100, 200, 500],
    MUR: [25, 50, 100, 200, 500, 1000, 2000],
    MVR: [5, 10, 20, 50, 100, 500],
    MWK: [20, 50, 100, 200, 500, 1000, 2000],
    MXN: [20, 50, 100, 200, 500, 1000],
    MYR: [1, 5, 10, 20, 50, 100],
    MZN: [20, 50, 100, 200, 500, 1000],
    NAD: [10, 20, 50, 100, 200],
    NGN: [5, 10, 20, 50, 100, 200, 500, 1000],
    NIO: [10, 20, 50, 100, 200, 500],
    NOK: [50, 100, 200, 500, 1000],
    NPR: [5, 10, 20, 50, 100, 500, 1000],
    NZD: [5, 10, 20, 50, 100],
    OMR: [0.5, 1, 5, 10, 20, 50],
    PAB: [1, 5, 10, 20],
    PEN: [10, 20, 50, 100, 200],
    PGK: [2, 5, 10, 20, 50, 100]
  };